import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@Sage/hoi-poi-ui';
import ConfirmModal from 'components/ConfirmModal';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';
import { BULK_MARKETING_SUBSCRIBE_CONFIRM_CLOSE_TIMEOUT } from './useBulkMarketingSubscribedConfirm';

const BulkMarketingSubscribedConfirmModal = memo(
    ({
        isOpen,
        isSubmitting,
        payload,
        onConfirm,
        onClose,
        closeTimeoutMS = BULK_MARKETING_SUBSCRIBE_CONFIRM_CLOSE_TIMEOUT,
    }) => (
        <ConfirmModal
            width="540px"
            isOpen={isOpen}
            title={getLiteral(payload?.title || '')}
            confirmText={getLiteral(payload?.confirmLiteral)}
            cancelText={getLiteral('action_cancel')}
            onConfirm={onConfirm}
            onClose={onClose}
            closeTimeoutMS={closeTimeoutMS}
            isLoading={isSubmitting}
        >
            {payload?.introLiteral && (
                <Text>
                    {getLiteralWithParameters(payload.introLiteral, payload.introParams || [])}
                </Text>
            )}
            {(payload?.bodyLiterals || []).map((literal, index) => (
                <Text key={`${literal}-${index}`}>{getLiteral(literal)}</Text>
            ))}
        </ConfirmModal>
    ),
);

BulkMarketingSubscribedConfirmModal.propTypes = {
    isOpen: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    payload: PropTypes.object,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    closeTimeoutMS: PropTypes.number,
};

export default BulkMarketingSubscribedConfirmModal;
